module.exports = __webpack_public_path__ + "static/img/banner-building.28d0b3d2.png";